import { NavLink } from "react-router-dom";
import { Home, Search, Heart, Store, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", label: "Accueil", icon: Home, testid: "bnav-home" },
  { to: "/recherche", label: "Recherche", icon: Search, testid: "bnav-search" },
  { to: "/favoris", label: "Favoris", icon: Heart, testid: "bnav-favorites" },
  { to: "/vendre", label: "Vendre", icon: Store, testid: "bnav-sell", highlight: true },
  { to: "/profil", label: "Compte", icon: User, testid: "bnav-profile" },
];

export default function BottomNav() {
  const { user, shop } = useAuth();
  // "Vendre" routes to merchant dashboard once the shop exists, otherwise to creation form
  const resolveTo = (it) => {
    if (it.to === "/profil" && !user) return "/connexion";
    if (it.to === "/vendre" && user && shop) return "/tableau-bord";
    return it.to;
  };
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-[#E8E6E1]">
      <div className="max-w-7xl mx-auto grid grid-cols-5 px-1 py-1">
        {items.map((item) => {
          const Icon = item.icon;
          const to = resolveTo(item);
          return (
            <NavLink
              key={item.to}
              to={to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2 gap-0.5 transition ${
                  item.highlight
                    ? "text-[#E65100]"
                    : isActive
                    ? "text-[#1A1918]"
                    : "text-[#73706B]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className={`h-8 w-8 rounded-lg flex items-center justify-center transition ${
                    item.highlight ? "bg-[#E65100] text-white" : isActive ? "bg-[#F3F1EC]" : ""
                  }`}>
                    <Icon className="h-4 w-4" />
                  </div>
                  <span className="text-[10px] font-medium">{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
